import React from "react"
import styled from "styled-components"
import Link from "next/link"
import WinItSmallLogo from "~/public/static/images/svg/winIt_small_logo.svg"
import DesktopContainer from "../DesktopContainer"

const HeaderContainer = styled.div`
  height: 56px;
  font-size: 1.2rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
`

const LogoContainer = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
`

const LogoText = styled.div`
  padding-left: 20px;
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  font-size: 1.3rem;
  margin-right: 20px;
  color: ${props => props.theme.colors.text.header};
`

const SubText = styled.div`
  padding-left: 20px;
  border-left: solid 1px ${props => props.theme.colors.text.inputPlaceholder};
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  color: ${props => props.theme.colors.text.inputPlaceholder};
  font-size: 1.1rem;
`

const LogoImg = styled.img`
  width: 43px;
  height: 28px;
  display: block;
`

const Header = () => {
  return (
    <DesktopContainer>
      <HeaderContainer>
        <Link href="/" passHref>
          <LogoContainer>
            <LogoImg
              src={WinItSmallLogo}
              alt="WinIt Logo"
            />
            <LogoText>WinIt</LogoText>
            <SubText>Careers</SubText>
          </LogoContainer>
        </Link>
      </HeaderContainer>
    </DesktopContainer>
  )
}

export default Header
